export default __webpack_public_path__ + "static/media/active-level-3.a3830cc9.svg";